import { useCallback } from "react";
import { InspectionInfo } from "../../models/workorders/Inspection";
import { saveInspection } from "../../models/inspections/Inspections";
import { removeInspectionFromLocal } from "../../util/InspectionsHelper";

export default function useCompleteInspection() {
  const completeInspection = useCallback(async (inspection: InspectionInfo) => {
    const {
      checkOverride,
      comments,
      currentTestEquip,
      inspectionDefinition,
      inspectionId,
      pointVals,
      woNumber,
      pointImages,
      pointComments,
      equipmentId,
      isEquipmentContext,
    } = inspection;
    const response = await saveInspection(
      woNumber,
      inspectionId,
      pointVals,
      inspectionDefinition,
      checkOverride,
      comments,
      currentTestEquip,
      pointImages,
      pointComments,
      equipmentId,
      isEquipmentContext
    );
    if (!response.isError)
      // Remove inspection from local storage if present
      await removeInspectionFromLocal(inspectionId, woNumber, equipmentId);
    return response;
  }, []);

  return { completeInspection };
}
